import { parseConfigBoolean, parseConfigNumber } from './utis';

export const sentry = {
  dsn: process.env.REACT_APP_SENTRY_DSN,
  enabled: parseConfigBoolean(process.env.REACT_APP_SENTRY_ENABLED),
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
  release: process.env.REACT_APP_SENTRY_RELEASE || '0.0.0',
  sampleRate: parseConfigNumber(process.env.REACT_APP_SENTRY_SAMPLE_RATE, 0.1),
  tracesSampleRate: parseConfigNumber(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE, 0.1),
};
